import { FC } from 'react'

import styles from './CircleLoader.module.scss'

export const CircleLoader: FC = () => {
  return (
    <div className={styles.requestingSpinnerWrapper}>
      <svg className={styles.requestingSpinnerSvg} viewBox="0 0 100 100">
        <circle
          className={styles.spinnerBackground}
          cx="50"
          cy="50"
          r="42"
          fill="none"
          stroke="#e3f2fd"
          strokeWidth="8"
        />

        <circle
          className={styles.spinnerProgress}
          cx="50"
          cy="50"
          r="42"
          fill="none"
          stroke="url(#gradient)"
          strokeWidth="8"
          strokeDasharray="80 184"
          strokeLinecap="round"
        />

        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#1976d2" />
            <stop offset="100%" stopColor="#42a5f5" />
          </linearGradient>
        </defs>
      </svg>

      <div className={styles.spinnerDots}>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </div>
    </div>
  )
}
